class CustomerReviewsCarousel {
  constructor(section) {
    this.section = section;
    this.carousel = section.querySelector("[data-reviews-carousel]");
    this.prevButton = section.querySelector(".carousel-arrow-prev");
    this.nextButton = section.querySelector(".carousel-arrow-next");
    this.cards = Array.from(this.carousel.querySelectorAll(".review-card"));

    if (!this.carousel) return;

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.updateButtonStates();

    // Auto-scroll functionality (optional)
    this.autoScrollInterval = null;
    this.startAutoScroll();

    // Pause auto-scroll on hover
    this.carousel.addEventListener("mouseenter", () => this.stopAutoScroll());
    this.carousel.addEventListener("mouseleave", () => this.startAutoScroll());
  }

  setupEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener("click", () => this.scroll("prev"));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener("click", () => this.scroll("next"));
    }

    // Update button states on scroll
    this.carousel.addEventListener("scroll", () => {
      this.updateButtonStates();
    });

    // Touch support for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    this.carousel.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    this.carousel.addEventListener("touchend", (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    });

    // Keyboard navigation
    this.section.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        this.scroll("prev");
      } else if (e.key === "ArrowRight") {
        this.scroll("next");
      }
    });
  }

  scroll(direction) {
    const cardWidth = this.cards[0]?.offsetWidth || 0;
    const gap = 24; // Match CSS gap
    const scrollAmount = cardWidth + gap;

    if (direction === "prev") {
      this.carousel.scrollBy({
        left: -scrollAmount,
        behavior: "smooth",
      });
    } else {
      this.carousel.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }

    // Reset auto-scroll timer
    this.stopAutoScroll();
    this.startAutoScroll();
  }

  handleSwipe(startX, endX) {
    const swipeThreshold = 50;
    const difference = startX - endX;

    if (Math.abs(difference) > swipeThreshold) {
      if (difference > 0) {
        // Swiped left, scroll right
        this.scroll("next");
      } else {
        // Swiped right, scroll left
        this.scroll("prev");
      }
    }
  }

  updateButtonStates() {
    if (!this.prevButton || !this.nextButton) return;

    const scrollLeft = this.carousel.scrollLeft;
    const maxScroll = this.carousel.scrollWidth - this.carousel.clientWidth;

    // Disable prev button if at start
    if (scrollLeft <= 10) {
      this.prevButton.style.opacity = "0.5";
      this.prevButton.style.pointerEvents = "none";
    } else {
      this.prevButton.style.opacity = "1";
      this.prevButton.style.pointerEvents = "auto";
    }

    // Disable next button if at end
    if (scrollLeft >= maxScroll - 10) {
      this.nextButton.style.opacity = "0.5";
      this.nextButton.style.pointerEvents = "none";
    } else {
      this.nextButton.style.opacity = "1";
      this.nextButton.style.pointerEvents = "auto";
    }
  }

  startAutoScroll() {
    // Auto-scroll every 5 seconds
    this.autoScrollInterval = setInterval(() => {
      const maxScroll = this.carousel.scrollWidth - this.carousel.clientWidth;
      const currentScroll = this.carousel.scrollLeft;

      if (currentScroll >= maxScroll - 10) {
        // Reset to start
        this.carousel.scrollTo({
          left: 0,
          behavior: "smooth",
        });
      } else {
        this.scroll("next");
      }
    }, 5000);
  }

  stopAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  }
}

// Initialize all customer review carousels on the page
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".customer-reviews-section");
  sections.forEach((section) => {
    new CustomerReviewsCarousel(section);
  });
});

// Reinitialize on section reload (for Shopify theme editor)
if (Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(".customer-reviews-section");
    if (section) {
      new CustomerReviewsCarousel(section);
    }
  });
}
